import { DIALOG_DATA } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { PalantirButtonComponent } from '../button/button.component';
import { PalantirButtonVariant } from '../button/button.type';
import { PalantirDialogRef } from '../dialog/dialog-ref.service';
import { PalantirDialogComponent } from '../dialog/dialog.component';
import { PalantirTextComponent } from '../text/text.component';
import type { PalantirConfirmDialogOptions } from './confirm-dialog.type';

@Component({
  selector: 'palantir-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PalantirDialogComponent, PalantirTextComponent, PalantirButtonComponent, NgClass],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PalantirConfirmDialogComponent {
  public title!: string;

  public text!: string;

  public cancelText?: string;

  public cancelVariant?: PalantirButtonVariant;

  public successText!: string;

  public successVariant?: PalantirButtonVariant;

  public reverseButtons?: boolean;

  public constructor(
    private readonly palantirDialogRef: PalantirDialogRef,
    @Inject(DIALOG_DATA) private readonly data: PalantirConfirmDialogOptions,
  ) {
    this.title = this.data.title;
    this.text = this.data.text;
    this.cancelText = this.data.cancelText;
    this.cancelVariant = this.data.cancelVariant;
    this.successText = this.data.successText;
    this.successVariant = this.data.successVariant;
    this.reverseButtons = this.data.reverseButtons;
  }

  public close() {
    void this.palantirDialogRef.close({ role: 'cancel' });
  }

  public confirm() {
    void this.palantirDialogRef.close({ role: 'success' });
  }
}
